import { Environment } from 'src/common/constants/Environment';

export function isTesting(nodeEnv?: string): boolean {
  return nodeEnv === Environment.TESTING;
}
